import { useCallback } from "react";
import * as d3 from "d3";

export const useCustomYAxisLeft = () => {
  const format = d3.format(",");

  return useCallback(
    (yAxisLeft: d3.Axis<d3.NumberValue>) => {
      yAxisLeft.tickFormat(format);
    },
    [format],
  );
};
